export default __webpack_public_path__ + "static/media/congratulation.8fc704ec.png";